const CheckoutSucess = () => {};

export default CheckoutSucess;
